import React from "react";
import { useSettings } from "@/context/SettingsContext";

export default function AnnouncementBar() {
    const { settings } = useSettings();
    const msg = settings.announcement || "Premium Quality  •  Competitive Making Charges  •  Discover Timeless Jewellery";
    const repeated = new Array(6).fill(msg);
    return (
        <div className="bg-[color:var(--charcoal)] text-[color:var(--ivory)] py-2.5 overflow-hidden border-b border-[color:var(--champagne)]/20" data-testid="announcement-bar">
            <div className="marquee">
                <div className="marquee-track eyebrow text-[color:var(--champagne-light)]">
                    {repeated.map((m, i) => (
                        <span key={i} className="flex items-center gap-6">
                            <span>{m}</span>
                            <span className="text-[color:var(--champagne)]">✦</span>
                        </span>
                    ))}
                    {repeated.map((m, i) => (
                        <span key={`d-${i}`} className="flex items-center gap-6">
                            <span>{m}</span>
                            <span className="text-[color:var(--champagne)]">✦</span>
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
